import { render } from "./NewIssuePanel.vue?vue&type=template&id=74c7238c"
import script from "./NewIssuePanel.vue?vue&type=script&lang=js"
export * from "./NewIssuePanel.vue?vue&type=script&lang=js"

import "./NewIssuePanel.vue?vue&type=style&index=0&id=74c7238c&lang=scss"
script.render = render

export default script